export const BRAND_NAME = "Death Stranding 2 Hub";
export const BRAND_SLUG = "deathstranding2";
export const BRAND_TAGLINE =
  "Launch tracker, spoiler-light guides, editions, and release notes for Death Stranding 2";
export const VISIBLE_LOGO_SRC = "/imgs/logos/clawhost-logo.svg";
export const PRIMARY_DOMAIN = "deathstranding2.lol";
export const PRIMARY_URL = `https://${PRIMARY_DOMAIN}`;
export const OPERATOR_NAME = "DeathStranding2.lol";
export const OPERATOR_URL = PRIMARY_URL;
export const SUPPORT_EMAIL = "gateszhang92@gmail.com";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
